<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container">
    <saleer-data :agency-code="agencyCode" />
  </div>
</template>

<script>
export default {
  name: 'Saleer',
  components: {
    saleerData: () => import('@/views/ita/components/saleerData.vue'),
  },
  data() {
    return {
      list: null,
      agencyCode: null,
    }
  },
  created() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
  },
  methods: {},
}
</script>
